/**
 * API base URL for axios.
 *
 * Development (`npm start`): uses `REACT_APP_API_BASE_URL` if set; otherwise
 * defaults to `http://localhost:4000/` so local login hits your local API (not
 * https://liber-x.com, which causes CORS from localhost:3000).
 *
 * Production build: uses `REACT_APP_PRODUCTION_API_BASE_URL`, then same-origin,
 * then https://liber-x.com/ as last resort.
 */
function normalizeApiBase(url) {
  if (url == null || String(url).trim() === "") {
    return null;
  }
  const s = String(url).trim();
  return s.endsWith("/") ? s : `${s}/`;
}

function resolveBaseUrl() {
  const isProd = process.env.NODE_ENV === "production";

  if (!isProd) {
    const fromEnv = normalizeApiBase(process.env.REACT_APP_API_BASE_URL);
    if (fromEnv != null) {
      return fromEnv;
    }
    // Backend `npm start` defaults to PORT 4000 (see backend/index.js).
    return "http://localhost:4000/";
  }

  const fromProdEnv = normalizeApiBase(
    process.env.REACT_APP_PRODUCTION_API_BASE_URL
  );
  if (fromProdEnv != null) {
    return fromProdEnv;
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/`;
  }

  return "https://liber-x.com/";
}

export const BASE_URL = resolveBaseUrl();
export const PDF_BASE_URL = BASE_URL;
